import {Injectable} from "@angular/core";
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";


@Injectable({providedIn: 'root'})
export class JyUserService extends BaseService {

  private url = 'api/user';  // URL to web api
  private loginUrl = 'api/authenticate/?_allow_anonymous=true';
  private validateUrl = 'api/validate';
  private logoutUrl = 'api/logout';
  private PswUrl = 'api/user/pswUpdate/?_allow_anonymous=true';
  private newLoginUrl = 'api/login';

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }


  current(): Observable<any> {
    const currentUserUrl = `${this.getUrl()}/current`;
    return this.http.get<any>(currentUserUrl).pipe(
      tap(_ => this.log(`current user`)),
      catchError(this.handleError<any>(`get current user`))
    );
  }


  login(data: any): Observable<any> {
    return this.http.post<any>(this.loginUrl, data).pipe(
      tap(_ => this.log(`login`)),
      catchError(this.handleError<any>(`login`))
    );
  }

  logout(data: any): Observable<any> {
    return this.http.post<any>(this.logoutUrl, data).pipe(
      tap(_ => this.log(`logout`)),
      catchError(this.handleError<any>(`logout`))
    );
  }

  validate(data: any): Observable<any> {
    return this.http.post<any>(this.validateUrl, data).pipe(
      tap(_ => this.log(`validate`)),
      catchError(this.handleError<any>(`validate`))
    );
  }

  updatePsw(param): Observable<any> {
    return this.http.put<any>(this.PswUrl,param).pipe(
      tap(_ => this.log(`Update user's password`)),
      catchError(this.handleError<any>(`Update user's password fail`)),
    );
  }

  newLogin(data: any): Observable<any> {
    return this.http.post<any>(this.newLoginUrl, data, httpOptions).pipe(
      tap(_ => this.log(`login`)),
      catchError(this.handleError<any>(`login`)),
    );
  }

  //  oa打开流程时根据oaUserId获取token
  getToken(userId):Observable<any> {
    return this.http.get(`api/oa-authenticate/${userId}?_allow_anonymous=true`,
      {
        headers: httpOptions.headers,
      }
    ).pipe(
      tap(() => this.log('getToken')),
      catchError(this.handleError('getToken'))
    );
  }

}

